<template>
  <div class="container">
    <div class="row">

      <div class="card">
        <div class="card-title text-center">Inicio de sesión</div>
        <div class="card-body">
          <div class="card-text">
            <form @submit="this.submitForm()">
              <div class="form-group">
                <label for="input-correo">Correo</label>
                <input
                class="form-control"
                  id="input-correo"
                  type="text"
                  v-model="form.formCorreo"
                />
              </div>
              <div class="form-group">
                <label for="input-password">Contraseña</label>
                <input
                class="form-control"
                  id="input-password"
                  type="password"
                  v-model="form.formPassword"
                />
              </div>
              <div class="form-group">
                <button class="form-control btn-gob-gold" type="submit">Iniciar sesión</button>
              </div>
            </form>
          </div>
        </div>
      </div>


    </div>
  </div>
</template>


<style scoped>
.form-errors {
  background-color: #c62828; /* Material Red 800 */
  border-radius: 16px;
  padding: 16px;
  color: #fafafa;
}

.form-group {
  padding: 8px;
}

.card {
  border-radius: 8px;
  margin-left: auto;
  margin-right:auto;
  margin-top: 32px;
  margin-bottom: 32px;
  padding: 8px;
  width: 80%;
}
</style>

<script>
import auth from "@/auth/auth";
import MD5 from 'crypto-js/md5';

export default {
  name: "Login",
  data() {
    return {
      errors: [],
      form: {
        formCorreo: "",
        formPassword: "",
      },
    };
  },
  methods: {
    ShowAlert(title, message, icon) {
      this.$swal({
        title: title,
        text: message,
        type: icon,
      }).then((result) => {
        if (result.isConfirmed) {
          //this.clearModel();
        }
      });
    },

    async submitForm() {
      try {
        var response = await auth.login(
          this.form.formCorreo,
          MD5(this.form.formPassword).toString()
        );

        const user = {
          email: response.data.mail,
          name: response.data.name,
          id: response.data.id,
        };

        auth.setUserLogged(user);

        this.$router.go("/");

        /* if (result != null) {
          const user = {
            email: this.email,
          };
          //auth.setUserLogged(user);
          //this.$router.push("/");
          //this.ShowAlert('Exito', "Inicio de sesion correcto ["+result.data.name+"]", 'success');
          console.info(result);
        } else {
          this.ShowAlert(
            "No autorizado",
            "No se encuentra el usuario o la contraseña es incorrecta",
            "error"
          );
        }*/
      } catch (error) {
        console.log(error);
        //this.error = true;
        this.ShowAlert(
          "Error",
          "Intenta enviar tu información nuevamente, [" + error + "`]",
          "error"
        );
      }
    },
  },
};
</script>
